import { createSlice } from '@reduxjs/toolkit'
import { getProviderHoldList } from './providerHoldThunk'

const initialState = {
  holdPatients: [],
  holdCensusFilters: JSON.parse(localStorage.getItem('holdCensusFilters')) || {},
  holdSearchText: '',
  holdPage: 0,
  lastHoldType: '',
  totalCount: 0,
}
const providerHoldSlice = createSlice({
  name: 'providerHold',
  initialState,
  reducers: {
    setProvHoldCensusFilters: (state, action) => {
      state.holdCensusFilters = action.payload
      // the saddest requirement of page refresh persistence
      localStorage.setItem('holdCensusFilters', JSON.stringify(action.payload))
    },
    setProviderHoldSearchText: (state, action) => {
      state.holdSearchText = action.payload
    },
    resetProviderHold: (state) => {
      state.holdPatients = []
      state.holdSearchText = ''
      state.holdPage = 0
      state.lastHoldType = ''
      state.totalCount = 0
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProviderHoldList.fulfilled, (state, action) => {
        if (action.payload) {
          if (action?.payload?.refresh) {
            state.holdPatients = action.payload?.inPatients || []
            state.holdPage = 0
          } else {
            state.holdPatients = [...state.holdPatients, ...(action.payload?.inPatients || [])]
            state.holdPage = action.payload?.holdPage || state.holdPage
          }
          state.totalCount = action.payload?.totalCount || 0
          state.lastHoldType = action.payload?.lastHoldType || ''
        }
      })
      .addCase(getProviderHoldList.rejected, (state, action) => {
        console.error(action?.payload)
      })
  },
})

export const { setProvHoldCensusFilters, setProviderHoldSearchText, resetProviderHold } =
  providerHoldSlice.actions
export const allHoldsFetched = (state) => {
  return state.providerHold.holdPatients?.length >= state.providerHold.totalCount
}

export default providerHoldSlice.reducer
